<div class="advantages-section">
  <h2 class="title">{{ 'advantages' | translate }}</h2>
  <div class="advantages-grid">
    <div class="advantage-item" *ngFor="let item of advantages; index as i">
      <div class="number">{{ i + 1 | number:'2.0' }}</div>
      <h3>{{ item.title | translate }}</h3>
      <p>{{ item.description | translate }}.</p>
    </div>
  </div>
</div>
